import * as firebase from "firebase/app";
import "firebase/analytics";
import "firebase/auth";
import "firebase/storage";
import "firebase/firestore";
import "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyAqyWS6YKT-5EE6BeFFi2-E6VtFFESCKKY",
  authDomain: "plataforma-vue-nome.firebaseapp.com",
  databaseURL: "https://plataforma-vue-nome-default-rtdb.firebaseio.com",
  projectId: "plataforma-vue-nome",
  storageBucket: "plataforma-vue-nome.appspot.com",
  messagingSenderId: "103040762634",
  appId: "1:103040762634:web:a8ff30246ea77b3594f0f3",
  measurementId: "G-XF32V9X4X2"
};
// Get a Firestore instance
const app = firebase.initializeApp(firebaseConfig);
firebase.analytics();

const firestore = app.firestore();

firestore.enablePersistence();

export const db = firestore;
export const rdb = app.database();

export const storage = firebase.storage(app);

export const auth = app.auth();
